import { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";

const ScrollUp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    visible && (
      <button
        onClick={scrollToUp}
        style={{
          position: "fixed",
          bottom: "30px",
          right: "30px",
          height: "50px",
          width: "50px",
          borderRadius: "50%",
          backgroundColor: "#684df4",
          color: "#ffffff",
          border: "none",
          outline: "none",
          cursor: "pointer",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
        }}
        aria-label="Scroll to top"
      >
        <FaChevronUp />
      </button>
    )
  );
};

export default ScrollUp;
